import { IS_DEVELOPMENT_MODE } from 'constants/ui';
import { useEffect, useMemo, useState } from 'react';
import { useZustandLanguagesKitStore, languageSelectors } from 'react-gldn-kit';
import { getBannersSelector, setBannersAction } from 'stores/banners/selectors';
import { useZustandBannersStore } from 'stores/banners/store';
import { Banners } from 'stores/banners/types';
import { getBannerPathSelector } from 'stores/configuration/selectors';
import { useZustandWebConfiguration } from 'stores/configuration/store';
import { isMobileDeviceSelector } from 'stores/device/selectors';
import { useZustandDeviceStore } from 'stores/device/store';

export const useBanners = () => {
  const banners = useZustandBannersStore(getBannersSelector);

  const bannersPath = useZustandWebConfiguration(getBannerPathSelector);

  const isMobile = useZustandDeviceStore(isMobileDeviceSelector);

  const setBanners = useZustandBannersStore(setBannersAction);

  const activeLang = useZustandLanguagesKitStore(
    languageSelectors.getActiveLanguageNameKitSelector
  );

  useEffect(() => {
    if (banners || !bannersPath) {
      return;
    }

    const fetching = async () => {
      try {
        const bannerResponse = await fetch(bannersPath, { cache: 'no-store' });

        const data = await bannerResponse.json();

        setBanners(data);
      } catch (error) {
        console.log('🚀 ~ fetching ~ error:', error);
      }
    };

    fetching();
  }, [banners, bannersPath]);

  // Notice rewrite logic for ui-kit

  return useMemo(() => {
    const mockBanners: Banners = { mobile: [], desktop: [] };

    const response = banners || mockBanners;

    const key = isMobile ? 'mobile' : 'desktop';

    const data = response[key] || [];

    return data
      .sort((b1, b2) => b1.order - b2.order)
      .map((b) => {
        const path = `${IS_DEVELOPMENT_MODE ? 'https://elon.casino' : ''}${
          b.path
        }`;

        const { translations } = b;

        const text =
          translations[activeLang]?.title || translations['en'].title || '';

        const subTitle =
          translations[activeLang]?.subTitle ||
          translations['en']?.subTitle ||
          '';

        const buttonText =
          translations[activeLang]?.buttonText ||
          translations['en']?.buttonText ||
          '';

        return {
          ...b,
          mobile: path,
          desktop: path,
          text,
          subTitle,
          buttonText,
        };
      });
  }, [isMobile, banners]);
};
